


















import Vue from 'vue'
import { Component } from 'vue-property-decorator';

@Component
({
    mounted: function() {
        // this.$store.commit('INBOUND_CALL_CHANGE',{});
        // this.$store.commit('OUTBOUND_CALL_CHANGE',{});
     }
})
export default class CallDirectionFilter extends Vue{
    get inboundChecked() {
        return this.$store.state.reports.filters.inboundChecked;
    }

    get outboundChecked() {
        return this.$store.state.reports.filters.outboundChecked;
    }

    inboundCallCheckedChanged(newVal: any) {
        this.$store.commit('INBOUND_CALL_CHANGE', {
            newVal
        });
    }

    outboundCallCheckedChanged(newVal: any) {
        this.$store.commit('OUTBOUND_CALL_CHANGE', {
            newVal
        });
    }
}
